import { render, staticRenderFns } from "./Respondent.vue?vue&type=template&id=a415028c&"
import script from "./Respondent.vue?vue&type=script&lang=js&"
export * from "./Respondent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports